module.exports = __webpack_public_path__ + "static/img/logo_green.fee15b0a.png";